import { render, staticRenderFns } from "./backHis.vue?vue&type=template&id=feccdd0a&scoped=true"
import script from "./backHis.vue?vue&type=script&lang=js"
export * from "./backHis.vue?vue&type=script&lang=js"
import style0 from "./backHis.vue?vue&type=style&index=0&id=feccdd0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feccdd0a",
  null
  
)

export default component.exports